export default () => {
	const ytPlayers = document.querySelectorAll('.youtube-player')
	var playerHeight = 576
	var playerWidth = 1024

	if (ytPlayers.length > 0) {
		window.YT.ready(function () {
			ytPlayers.forEach((ytvideo, i) => {
				var video_id = ytvideo.getAttribute('data-id')
				var playbtn = ytvideo.nextElementSibling
				var player = new YT.Player(ytvideo, {
					height: playerHeight,
					width: playerWidth,
					videoId: video_id,
					playerVars: { rel: 0, showinfo: 0, ecver: 2 },
				})
				playbtn.addEventListener('click', function () {
					setTimeout(function () {
						player.playVideo()
					}, 200)
					setTimeout(function () {
						playbtn.classList.add('hide-done')
					}, 700)
				})
			})
		})
	}
}